<template>
  <div class="ui two column grid">
    <generic-container
      class="column"
      style="margin-bottom: 0;"
      v-for="(role, index) in process.ngn_roles"
      :key="index"
      :title="role.name"
      :configurable="false"
      icon="users"
    >
      <div class="ui form">
        <div class="field">
          <label for>{{ $t("search user") }}</label>
          <div class="ui search" ref="role_search" :data-r="role.role_id">
            <div class="ui icon input">
              <input class="prompt" type="text" :placeholder="$t('search')" />
              <i class="search icon"></i>
            </div>
            <div class="results"></div>
          </div>
        </div>
        <!-- <h4 class="ui dividing header">{{$t("suscriptions")}}</h4> -->
        <div
          class="ui label"
          v-for="(suscription, index) in role.ngn_enrollments"
          :key="index"
        >
          {{ suscription.usr_user.name }}
          <i
            class="red close icon"
            @click="unsuscribe(suscription, role.role_id, index)"
          ></i>
        </div>
        <!-- <div class="ui middle aligned divided selection list">
          <div class="item" v-for="(suscription, index) in role.ngn_enrollments" :key="index">
            <div class="right floated content">
              <div
                class="ui mini icon red button"
                @click="unsuscribe(suscription, role.role_id, index)"
              >
                <i class="trash icon"></i>
              </div>
            </div>
            <i class="blue user icon"></i>
            <div class="content">{{ suscription.usr_user.name }}</div>
          </div>
        </div>-->
      </div>
    </generic-container>
  </div>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { local_api, error_toast } from "@/utils";

export default {
  name: "EnrollmentManager",
  components: { GenericContainer },
  props: { process: Object },
  data() {
    return {};
  },
  methods: {
    unsuscribe(suscription, roleId, index) {
      let vm = this;
      local_api(vm, "post", "/ngine_core/process/do-unsuscribe", {
        i: suscription.uuid,
      })
        .then(() => {
          let trgtRole = vm.process.ngn_roles.find((r) => r.role_id == roleId);
          if (trgtRole) {
            trgtRole.ngn_enrollments.splice(index, 1);
          }
        })
        .catch((err) => {
          error_toast(err);
        })
        .finally(() => {
          vm.processing = false;
        });
    },
    init() {
      let vm = this;
      window.jQuery(vm.$refs.role_search).search({
        apiSettings: {
          action: "search user",
          beforeXHR: function(xhr) {
            let token = vm.$session.get("token");
            if (token) {
              xhr.setRequestHeader("x-access-token", token);
            }
            return xhr;
          },
          onResponse: function(response) {
            if (!response.success) error_toast(response.error);
            else {
              var _response = {
                results: [],
              };
              response.data.map((r) => {
                _response.results.push({
                  title: r.name,
                  description: r.description,
                  user: r,
                });
              });
              return _response;
            }
          },
        },
        onSelect(result) {
          let $element = window.jQuery(this);
          let roleId = $element.data("r");
          local_api(vm, "post", "/ngine_core/process/do-suscribe", {
            r: roleId,
            u: result.user.encrypted_id,
          })
            .then((response) => {
              let trgtRole = vm.process.ngn_roles.find(
                (r) => r.role_id == roleId,
              );
              if (trgtRole) {
                trgtRole.ngn_enrollments.push(response);
              }
            })
            .catch((err) => {
              error_toast(err);
            })
            .finally(() => {
              vm.processing = false;
            });
        },
      });
    },
  },
};
</script>
